import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8497eefa")

_pushScopeId("data-v-8497eefa")
const _hoisted_1 = { class: "report-info" }
const _hoisted_2 = {
  class: "b-main",
  id: "m-body"
}
const _hoisted_3 = { class: "exportBtn" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "title" }, "实训报告", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_button = _resolveComponent("a-button")
  const _component_back_header_vue = _resolveComponent("back-header-vue")
  const _directive_print = _resolveDirective("print")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_back_header_vue, {
      onBack: _ctx.back,
      backMsg: "首页"
    }, {
      body: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _withDirectives(_createVNode(_component_a_button, { type: "primary" }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            }, 512), [
              [_directive_print, _ctx.printObj]
            ])
          ]),
          _hoisted_5,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.componentList, (com) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(com.name), {
              key: com.uuid,
              data: com.data
            }, null, 8, ["data"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["onBack"])
  ]))
})